
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CallbackStatusIcon } from '@/components/nuvemshop/callback/CallbackStatusIcon';
import { BuildVersionIndicator } from '@/components/nuvemshop/callback/BuildVersionIndicator';
import { CallbackStatusMessage } from '@/components/nuvemshop/callback/CallbackStatusMessage';
import { CallbackActions } from '@/components/nuvemshop/callback/CallbackActions';
import { DebugInfo } from '@/components/nuvemshop/callback/DebugInfo';
import { useNuvemshopCallback } from '@/hooks/nuvemshop/useNuvemshopCallback';

const NuvemshopCallback = () => {

  const {
    status,
    message,
    details,
    buildVersion,
    handleRetry,
    handleGoBack
  } = useNuvemshopCallback();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <CallbackStatusIcon status={status} />
          </div>
          <CardTitle className={`text-xl ${
            status === 'success' ? 'text-green-700' : 
            status === 'error' ? 'text-red-700' : 
            'text-blue-700'
          }`}>
            Integração Nuvemshop
          </CardTitle>
          <CardDescription>
            {message}
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <BuildVersionIndicator buildVersion={buildVersion} />

          <CallbackStatusMessage status={status} details={details} />

          <CallbackActions 
            status={status}
            onRetry={handleRetry}
            onGoBack={handleGoBack}
          />

          <DebugInfo buildVersion={buildVersion} />
        </CardContent>
      </Card>
    </div>
  );
};

export default NuvemshopCallback;
